import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { IDrawingShapeData, ICTTransform2D } from '@tencent/slide-sdk-model';
import _set from 'lodash/set';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { CopiedKeyType } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';

// 本文件为原有逻辑迁移，未重构
export class ElementSdkDataModify {
    public static adjustElementPosition(sdkData: IDrawingShapeData, slide?: ISlideModel, key?: string) {
        let offsetLeft = 0;
        let offsetTop = 0;
        let occupied = false;
        const checkOccupied = (group) => {
            group.children?.length && group.children.forEach((shape) => {
                if (shape.type === UIModelType.GROUP) {
                    checkOccupied(shape); // 递归查找groupShape
                }
                let shapeSdkXfrm;
                switch (key) {
                    case CopiedKeyType.OWN:
                        shapeSdkXfrm = shape.sdkData.getOwnedData().spPr?.xfrm;
                        break;
                    case CopiedKeyType.INHERIT:
                        shapeSdkXfrm = shape.sdkData.props.spPr?.xfrm;
                        break;
                    default: {
                        // 3.0数据下非选择性粘贴场景 或者 2.0数据场景
                        shapeSdkXfrm = shape.sdkData.props.spPr?.xfrm;
                    }
                }
                if (ElementSdkDataModify.checkFrame(shapeSdkXfrm, sdkData, offsetLeft, offsetTop)) {
                    // 被占用
                    occupied = true;
                    offsetLeft += 100000;
                    offsetTop += 100000;
                    return false; // 存在重复的，结束跳出整个循环
                }
            });
        };
        slide && checkOccupied(slide);
        if (occupied) {
            if (sdkData.spPr?.xfrm?.off !== undefined) {
                // @ts-ignore
                sdkData.spPr.xfrm.off.x += offsetLeft;
                // @ts-ignore
                sdkData.spPr.xfrm.off.y += offsetTop;
            } else {
                _set(sdkData, 'spPr.xfrm.off.x', 0);
                _set(sdkData, 'spPr.xfrm.off.y', 0);
            }
        }
    }

    public static checkAndAdjustElementPosition = (newElementSdkData) => {
        for (let i = 0; i < newElementSdkData.length; i++) {
            const currentSdkData = newElementSdkData[i];
            for (let j = 0; j < i; j++) {
                const tempSdkData = newElementSdkData[j];
                if (tempSdkData.spPr.xfrm?.off && currentSdkData.spPr.xfrm?.off
                    && tempSdkData.spPr.xfrm.off?.x === currentSdkData.spPr.xfrm.off?.x
                    && tempSdkData.spPr.xfrm.off?.y === currentSdkData.spPr.xfrm.off?.y
                    && tempSdkData.spPr.xfrm.ext?.cx === currentSdkData.spPr.xfrm.ext?.cx
                    && tempSdkData.spPr.xfrm.ext?.cy === currentSdkData.spPr.xfrm.ext?.cy) {
                    // 被占用
                    _set(currentSdkData, 'spPr.xfrm.off.x', currentSdkData.spPr.xfrm.off?.x + 100000);
                    _set(currentSdkData, 'spPr.xfrm.off.y', currentSdkData.spPr.xfrm.off?.y + 100000);
                }
            }
        }
    };

    private static checkFrame(
        shapeSdkXfrm: ICTTransform2D, sdkData: IDrawingShapeData,
        offsetLeft: number, offsetTop: number,
    ) {
        return shapeSdkXfrm?.off && sdkData.spPr?.xfrm?.off
            && shapeSdkXfrm.off?.x === Number(sdkData.spPr.xfrm.off?.x) + offsetLeft
            && shapeSdkXfrm.off?.y === Number(sdkData.spPr.xfrm.off?.y) + offsetTop
            && shapeSdkXfrm.ext?.cx === sdkData.spPr.xfrm.ext?.cx
            && shapeSdkXfrm.ext?.cy === sdkData.spPr.xfrm.ext?.cy;
    }
}
